/* Free Society UI enhancements */
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const post = (url, body) => fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then((r) => r.json());
  const SECTIONS = ['cart-drawer', 'cart-count'];

  function emitCart(cart) {
    if (window.MinimogEvents && window.MinimogTheme && cart && cart.sections) {
      window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, { cart });
    } else {
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
    }
  }

  /* keep drawer count + coupon chip states in sync with the real cart */
  function syncFromCart(cart) {
    if (!cart) return;
    if (cart.item_count != null) document.querySelectorAll('[data-fs-cart-count]').forEach((el) => (el.textContent = cart.item_count));
    const codes = cart.discount_codes || [];
    document.querySelectorAll('[data-fs-code]').forEach((chip) => {
      const code = chip.dataset.fsCode.toLowerCase();
      const hit = codes.find((d) => d.code.toLowerCase() === code);
      const label = chip.querySelector('span');
      if (!chip.dataset.fsLabel && label) chip.dataset.fsLabel = label.textContent;
      chip.classList.remove('is-applied', 'is-pending', 'is-loading');
      if (hit && hit.applicable) { chip.classList.add('is-applied'); if (label) label.textContent = 'Applied ✓ · tap to remove'; }
      else if (hit) { chip.classList.add('is-pending'); if (label) label.textContent = 'Not applicable on this cart · tap to remove'; }
      else if (label && chip.dataset.fsLabel) label.textContent = chip.dataset.fsLabel;
    });
  }
  const resync = () => fetch('/cart.js').then((r) => r.json()).then(syncFromCart).catch(() => {});
  document.addEventListener('cart:updated', () => setTimeout(resync, 60));
  document.addEventListener('click', (e) => { if (e.target.closest('.m-cart-icon-bubble')) setTimeout(resync, 120); });

  /* coupon chips + add-on in drawer */
  document.addEventListener('click', async (e) => {
    const chip = e.target.closest('[data-fs-code]');
    if (chip) {
      e.preventDefault();
      chip.classList.add('is-loading');
      try {
        const code = chip.dataset.fsCode;
        const cart = await fetch('/cart.js').then((r) => r.json());
        let codes = (cart.discount_codes || []).map((d) => d.code);
        const has = codes.some((c) => c.toLowerCase() === code.toLowerCase());
        codes = has ? codes.filter((c) => c.toLowerCase() !== code.toLowerCase()) : codes.concat(code);
        const res = await post('/cart/update.js', { discount: codes.join(','), sections: SECTIONS });
        emitCart(res);
        setTimeout(() => syncFromCart(res), 80);
      } catch (err) { console.error(err); chip.classList.remove('is-loading'); }
      return;
    }
    const add = e.target.closest('[data-fs-addon]');
    if (add) {
      e.preventDefault();
      add.classList.add('is-loading');
      try {
        await post('/cart/add.js', { items: [{ id: Number(add.dataset.fsAddon), quantity: 1 }] });
        emitCart(await post('/cart/update.js', { sections: SECTIONS }));
      } catch (err) { console.error(err); add.classList.remove('is-loading'); }
    }
  });

  /* share row: copy link + native share */
  document.addEventListener('click', async (e) => {
    const copy = e.target.closest('[data-fs-copy]');
    if (copy) {
      e.preventDefault();
      try { await navigator.clipboard.writeText(copy.dataset.fsCopy); } catch (_) {}
      const row = copy.closest('.fs-share');
      if (row) { row.classList.add('is-copied'); setTimeout(() => row.classList.remove('is-copied'), 1800); }
      return;
    }
    const ns = e.target.closest('[data-fs-native-share]');
    if (ns && navigator.share) {
      e.preventDefault();
      navigator.share({ title: ns.dataset.title, url: ns.dataset.url }).catch(() => {});
    }
  });
  document.querySelectorAll('[data-fs-native-share]').forEach((b) => { if (!navigator.share) b.hidden = true; });

  /* hover zoom on main product image (desktop) */
  function initZoom() {
    if (!matchMedia('(hover: hover) and (min-width: 1024px)').matches) return;
    document.addEventListener('mousemove', (e) => {
      const box = e.target.closest && e.target.closest('.m-main-product--media .m-product-media');
      document.querySelectorAll('.m-product-media.fs-zoom').forEach((el) => { if (el !== box) el.classList.remove('fs-zoom'); });
      if (!box) return;
      const img = box.querySelector('img');
      if (!img) return;
      const r = box.getBoundingClientRect();
      img.style.transformOrigin = ((e.clientX - r.left) / r.width) * 100 + '% ' + ((e.clientY - r.top) / r.height) * 100 + '%';
      box.classList.add('fs-zoom');
    });
  }

  /* add-to-cart: product image flies into the bag */
  function pickVisible(sel) {
    let best = null, bestArea = 0;
    document.querySelectorAll(sel).forEach((i) => {
      const r = i.getBoundingClientRect();
      const w = Math.min(r.right, innerWidth) - Math.max(r.left, 0), h = Math.min(r.bottom, innerHeight) - Math.max(r.top, 0);
      const area = w > 0 && h > 0 ? w * h : 0;
      if (area > bestArea) { bestArea = area; best = i; }
    });
    return best;
  }
  let lastImg = null, lastAt = 0, lastBtn = null;
  document.addEventListener('click', (e) => {
    const b = e.target.closest('.m-add-to-cart, .m-atc-btn, button[name="add"], .sticky-atc-form button[type="submit"]');
    if (!b) return;
    const scope = b.closest('.m-product-card, [class*="quick-view"], .m-main-product--info, .m-sticky-addtocart');
    let img = null;
    if (scope && scope.classList.contains('m-product-card')) img = scope.querySelector('.m-product-card__main-image img');
    else if (scope && /quick-view/.test(scope.className)) img = scope.querySelector('img');
    if (!img) img = pickVisible('.m-main-product--media img');
    lastImg = img; lastBtn = b; lastAt = Date.now();
  }, true);

  /* VNV-style confirmation: button turns green and says Added to bag */
  function markAdded(btn) {
    if (!btn || !btn.classList.contains('m-add-to-cart')) return;
    const t = btn.querySelector('.m-add-to-cart--text');
    if (!t) return;
    const orig = btn.dataset.atcText || 'Add to cart';
    clearTimeout(btn._fsT);
    setTimeout(() => { btn.classList.add('fs-added'); t.textContent = 'Added to bag ✓'; }, 350);
    btn._fsT = setTimeout(() => { btn.classList.remove('fs-added'); t.textContent = orig; }, 2600);
  }

  function bagEl() {
    return [...document.querySelectorAll('.m-cart-icon-bubble')].find((el) => el.offsetParent !== null);
  }
  function fly(img) {
    const bag = bagEl();
    if (!img || !bag) return;
    const a = img.getBoundingClientRect(), z = bag.getBoundingClientRect();
    if (!a.width) return;
    const c = document.createElement('img');
    c.src = img.currentSrc || img.src;
    c.className = 'fs-fly';
    Object.assign(c.style, { left: a.left + 'px', top: a.top + 'px', width: a.width + 'px', height: a.height + 'px' });
    document.body.appendChild(c);
    const dx = z.left + z.width / 2 - (a.left + a.width / 2), dy = z.top + z.height / 2 - (a.top + a.height / 2);
    const anim = c.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1 },
      { transform: 'translate(0,-24px) scale(.62)', opacity: 1, offset: 0.25 },
      { transform: 'translate(' + dx * 0.55 + 'px,' + (dy * 0.55 - 90) + 'px) scale(.38)', opacity: 1, offset: 0.6 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.1)', opacity: 0.6 }
    ], { duration: 1000, easing: 'cubic-bezier(.45,.05,.55,.95)' });
    anim.onfinish = () => { c.remove(); bag.classList.remove('fs-pop'); void bag.offsetWidth; bag.classList.add('fs-pop'); };
  }
  const of = window.fetch;
  window.fetch = async function (...args) {
    const res = await of.apply(this, args);
    try {
      const u = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
      if (/\/cart\/add/.test(u) && res.ok && Date.now() - lastAt < 8000) { if (lastImg && !reduce) fly(lastImg); markAdded(lastBtn); lastImg = null; lastBtn = null; }
    } catch (_) {}
    return res;
  };

  /* subtle fade-up of sections as they scroll in */
  function initReveal() {
    if (reduce || !('IntersectionObserver' in window)) return;
    const main = document.querySelector('main') || document.body;
    const secs = [...main.querySelectorAll('.shopify-section')].filter((s) =>
      !s.parentElement.closest('.shopify-section') &&
      s.getBoundingClientRect().top > window.innerHeight &&
      !s.querySelector('.m-sticky-addtocart, m-cart-drawer, [class*="sticky"]')
    );
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (!en.isIntersecting) return;
        const s = en.target;
        s.classList.add('fs-in');
        io.unobserve(s);
        setTimeout(() => s.classList.remove('fs-reveal', 'fs-in'), 900);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    secs.forEach((s) => { s.classList.add('fs-reveal'); io.observe(s); });
  }

  const start = () => { initZoom(); initReveal(); resync(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();